/**
 * @fileoverview GET handler for the "/apps/:app_group_id/charts/line" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdChartsLine } from "./constants";
import type { ChartsLineResult } from "./types";
import { isChartsLineResult } from "./validators";

export const useLineChartsApiQuery = reactQueryFetcherAdapter(
  appsAppGroupIdChartsLine,
  (signal: AbortSignal, appGroupId: string, startDate: number, endDate: number): Promise<ChartsLineResult> => {
    return fetch(
      `/apps/${appGroupId}/charts/line`,
      "GET",
      {
        start_date: startDate,
        end_date: endDate,
      },
      { signal }
    );
  },
  isChartsLineResult
);
